import { type AuthConfig } from 'angular-oauth2-oidc';

import { type AppEnvironment } from './environment.model';

const keycloak: AuthConfig = {
  issuer: 'https://login.vastaa.ru/realms/vasta-dev',
  clientId: 'analytics-ui',
  redirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: false,
};

export const environment = {
  production: false,
  authEnabled: true,
  apiUrl: 'https://analytics.dev.vastaa.ru/api/api',
  useMockData: false,
  baseHref: '/',
  keycloak,
} satisfies AppEnvironment;
